import { Modal, Button, Spin } from "antd";
import React, { useEffect, useState } from "react";
import domtoimage from "dom-to-image-more";
import { professionalService } from "../../_services";

export const ImageView = ({ imageOpen, imageUrl, onClose, name, id }) => {
  const [mergeData, setMergeData] = useState();
  const [loading, setLoading] = useState(true);
  const getcriminalbyid = (id) => {
    setMergeData();
    professionalService.getCriminalsById(id).then((res) => {
      setMergeData(res);
    });
  };
  useEffect(() => {
    if (!id) return;

    const fetchData = async () => {
      setLoading(true);
      try {
        await getcriminalbyid(id);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  const downloadFullPreview = async () => {
    const node = document.getElementById("cmis-preview");

    const blob = await domtoimage.toBlob(node, {
      bgcolor: "#ffffff",
      cacheBust: true,
      style: {
        transform: "scale(1)",
        transformOrigin: "top left",
      },
    });

    const url = URL.createObjectURL(blob);

    const name1 = mergeData?.basicInfo[0]?.name;
    const link = document.createElement("a");
    link.href = url;
    link.download = name1 ? `${name1}.png` : "CMIS_Record.png";
    link.click();

    URL.revokeObjectURL(url);
  };

  return (
    <Modal
      title={<div style={{ fontWeight: 600, fontSize: 18 }}>Image Preview</div>}
      open={imageOpen}
      onCancel={onClose}
      centered
      width={850}
      footer={[
        <Button key="download" type="primary" onClick={downloadFullPreview}>
          Download Image
        </Button>,
        <Button key="close" onClick={onClose}>
          Close
        </Button>,
      ]}
    >
      {loading ? (
        <Spin style={{ textAlign: "center" }} size="large" />
      ) : (
        <div
          id="cmis-preview"
          style={{
            background: "#ffffff",
            border: "1px solid #d9d9d9",
            padding: "16px",
          }}
        >
          {/* Top Info */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "180px 1fr",
              rowGap: "10px",
              marginBottom: "16px",
              fontSize: "15px",
            }}
          >
            <strong>CMIS ID :</strong>
            <span>{id || "-"}</span>

            <strong>नाव :</strong>
            <span>{name || mergeData?.basicInfo[0]?.name || "-"}</span>
          </div>

          {/* Image */}
          <div
            style={{
              border: "1px solid #d9d9d9",
              padding: "12px",
              textAlign: "center",
              background: "#fafafa",
            }}
          >
            <img
              src={imageUrl}
              alt="Preview"
              style={{
                maxWidth: "100%",
                maxHeight: "60vh",
                objectFit: "contain",
              }}
            />
          </div>

          {/* Caption AFTER image */}
          <div
            style={{
              marginTop: "12px",
              fontSize: "15px",
            }}
          >
            <strong>लघुशीर्षक :</strong>{" "}
            {mergeData?.basicInfo[0]?.headingNames?.join(", ")}
          </div>
        </div>
      )}
    </Modal>
  );
};
